import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async () => {
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://loyalflow.co.il/update-password', // החלף ל־Netlify אם צריך
    });

    if (error) {
      toast.error('שגיאה בשליחת קישור איפוס');
    } else {
      toast.success('קישור איפוס נשלח למייל');
      navigate('/login');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-indigo-100 via-white to-purple-100">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full space-y-7 bg-white p-10 rounded-3xl shadow-2xl border border-indigo-100"
        style={{
          boxShadow: '0 8px 32px 0 rgba(99,102,241,0.10), 0 1.5px 8px 0 #a5b4fc22',
        }}
      >
        <div className="flex flex-col items-center mb-2">
          <div className="bg-indigo-50 rounded-full p-3 mb-2 shadow-sm">
            <svg width="36" height="36" fill="none" viewBox="0 0 24 24">
              <rect width="24" height="24" rx="12" fill="#6366f1" fillOpacity="0.08"/>
              <path d="M4 8.5A2.5 2.5 0 016.5 6h11A2.5 2.5 0 0120 8.5v7A2.5 2.5 0 0117.5 18h-11A2.5 2.5 0 014 15.5v-7zm2.13-.62A1 1 0 006.5 8h11a1 1 0 00.87-.5L12 13.25 6.13 7.88z" fill="#6366f1"/>
            </svg>
          </div>
          <h2 className="text-2xl font-extrabold text-gray-800 mb-1">איפוס סיסמה</h2>
          <p className="text-gray-600 text-sm text-center max-w-xs">
            הזן את כתובת האימייל שלך ונשלח אליך קישור לאיפוס הסיסמה.<br />
            בדוק את תיבת הדואר הנכנס (ואולי גם את הספאם).
          </p>
        </div>
        <input
          type="email"
          placeholder="כתובת אימייל"
          className="w-full px-4 py-3 border border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 transition"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          onClick={handleReset}
          disabled={loading}
          className="w-full bg-gradient-to-r from-indigo-500 to-purple-500 text-white py-3 rounded-lg font-semibold text-lg shadow-md hover:from-indigo-600 hover:to-purple-600 transition disabled:opacity-50"
        >
          {loading ? 'שולח...' : 'שלח קישור לאיפוס'}
        </button>
        <div className="text-xs text-gray-400 text-center mt-2">
          חזרה <span className="text-indigo-500 cursor-pointer underline" onClick={() => navigate('/login')}>לעמוד התחברות</span>
        </div>
      </motion.div>
    </div>
  );
}
